module.exports = __webpack_public_path__ + "img/plug_power.51831db7.png";